import { Link } from "react-router";
import NoResultsImage from "../../../components/assets/no-results.png";
import { ROUTES } from "~/services/const";

export default function NoResults() {
  return (
    <div className="mx-auto flex flex-col items-center  gap-4 text-gray-600 px-2 py-8 w-full max-w-lg text-center">
      <h3 className="text-xl font-semibold mb-4">Não encontramos espetáculos para esta sala :(</h3>
      <img src={NoResultsImage} width={400} className="mb-10" />
      <p className="mb-4">Tenta novamente mais tarde, estamos sempre a adicionar novas peças.</p>
      <p className="text-sm text-gray-500">
        Sabes de algum espetáculo que não está na plataforma?
        <br />
        <Link to={ROUTES.ADD_NEW_PLAY} className="underline">
          Clica aqui para adicionar
        </Link>
        .
      </p>
    </div>
  );
}
